
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"10.638","height":"13.184"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_19278","data-name":"Path 19278","d":"M8.319 7.092a3.546 3.546 0 10-3.546-3.546 3.546 3.546 0 003.546 3.546zm0-5.91a2.364 2.364 0 11-2.364 2.364 2.364 2.364 0 012.364-2.364zm0 7.092C5.383 8.277 3 9.657 3 12.593a.591.591 0 101.182 0c0-2.285 1.852-3.137 4.137-3.137s4.137.852 4.137 3.137a.591.591 0 101.182 0c-.003-2.936-2.383-4.316-5.319-4.319z","transform":"translate(-3)","fill":"#5f6368"}})])
          )
        }
      }
    